function SpinnerModule(moduleEle) {
  var module = this;
  module.moduleEle = moduleEle;
  module.spinnerTimeout = 100;
  module.spinnerTimeoutNumber = null;

  module.onBeforeServerCall = function (eventArgs) {
    //console.log('SpinnerModule.onBeforeServerCall()');
    module.spinnerTimeoutNumber = window.setTimeout(function () {
      //window.clearTimeout(module.spinnerTimeoutNumber);
      module.showSpinner();
    }, module.spinnerTimeout);
  }

  module.onServerComplete = function (eventArgs) {
    //console.log('SpinnerModule.onServerSuccess()');
    module.hideSpinner();
  }

  module.showSpinner = function () {
    module.moduleEle.removeClass('hidden');
  }

  module.hideSpinner = function () {
    window.clearTimeout(module.spinnerTimeoutNumber);
    module.moduleEle.addClass('hidden');
  }
}

instant.list.settings.moduleClasses['SpinnerModule'] = SpinnerModule;